import React, { useState, useEffect } from "react";
import { browserHistory } from "react-router";

import getByAlias from "api/restaurant/getByAlias.js";

import RestaurantInfo from "components/RestaurantDetails/RestaurantInfo.js";
import Score from "components/RestaurantDetails/Score.js";
import RestaurantHead from "components/RestaurantDetails/RestaurantHead.js";
import RestaurantImage from "components/RestaurantDetails/RestaurantImage.js";
import RestaurantImages from "components/RestaurantDetails/RestaurantImages.js";
import BaseMap from "components/RestaurantDetails/BaseMap.js";
import FacebookReviews from "components/RestaurantDetails/FacebookReviews.js";
import RestaurantReviews from "components/RestaurantDetails/RestaurantReviews.js";
import WriteReview from "components/RestaurantDetails/WriteReview.js";
import RestaurantReservation from "components/RestaurantDetails/RestaurantReservation3.js";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

function RestaurantDetails(props) {
  const [restaurant, setRestaurant] = useState({});

  console.log(props);
  const [reviewPopup, setReviewPopup] = useState(false);
  const [reservation, setReservation] = useState(false);
  useEffect(() => {
    const searchQuery = props.location.search;
    const [, name] = searchQuery.split("?");
    getByAlias(name)
      .then(res => {
        console.log("res", res, props.user);

        setRestaurant(res);
        return null;
      })
      .catch(err => console.log("err", err));
  }, [props.location.search]);

  if (restaurant && restaurant._id) {
    let restaurantImages = [];
    if (restaurant.restaurantImage && restaurant.restaurantImage.length > 0) {
      restaurantImages = restaurantImages.concat(restaurant.restaurantImage);
    }
    if (restaurant.photo && restaurant.photo.length > 0) {
      restaurant.photo.forEach(element => {
        if (element.approved) {
          const el = {
            url: element.image_url,
            _id: element._id,
            userId: element.userId,
            date: element.date
          };
          restaurantImages.push(el);
        }
      });
    }
    // restaurant.scoreOverall = restaurant.scoreOverall;
    // restaurant.scorePlace = restaurant.scorePlace;
    // restaurant.scoreFood = restaurant.scoreFood;
    // restaurant.scoreService = restaurant.scoreService;
    //
    // restaurant.price = restaurant.price;

    // TODO condizione per la prenotazione
    let isReservationEnabled = restaurant && restaurant.reservationData;

    return (
      <div className="restaurant-details-container detailsContainer">
        {reservation ? (
          <div>
            <style>{"body{ position: fixed; overflow: hidden; }"}</style>
            <div
              className="popup-black-layer"
              onClick={() => {
                setReservation(false);
              }}
            />
            <div className="popup-container">
              <div className="popup-title">
                Prenota
                <div
                  className="popup-close-button"
                  onClick={() => {
                    setReservation(false);
                  }}
                >
                  <i className="fa fa-times" />
                </div>
              </div>
              <div className="popup-content">
                <RestaurantReservation
                  defaultLanguage={"it"}
                  userLanguage={"it"}
                  showReservationPopup={true}
                  showReservation={true}
                  restaurantId={restaurant._id}
                  user={props.user}
                  restaurant={restaurant}
                  // positions: PropTypes.array.isRequired
                  reservation={restaurant.reservationData}
                />
              </div>
            </div>
          </div>
        ) : null}
        <div className="restaurant-details-info-main restaurant-head-mobile">
          <RestaurantHead
            restaurant={restaurant}
            isLogged={!!(props.user && props.user._id)}
          />
          {isReservationEnabled ? (
            <button
              className="show-more-results grey"
              onClick={() => {
                setReservation(true);
              }}
            >
              Prenota Ora
            </button>
          ) : null}
        </div>
        {restaurantImages && restaurantImages.length > 3 ? (
          <RestaurantImages restaurantImages={restaurantImages} />
        ) : (
          <RestaurantImage restaurant={restaurant} />
        )}
        <div className="restaurant_basic_info">
          <h1>{restaurant.name}</h1>{" "}
          {restaurant.categories[0] ? (
            <h2> - {restaurant.categories[0][`label_it`]}</h2>
          ) : (
            ""
          )}
          {restaurant[`addressIT`] && restaurant[`addressIT`].admin2 ? (
            <span>, {restaurant[`addressIT`].admin2}</span>
          ) : (
            ""
          )}
        </div>
        <BaseMap restaurant={restaurant} />
        <div className="restaurant-details-info-container">
          <div className="restaurant-details-info-main restaurant-head-desktop">
            <RestaurantHead
              restaurant={restaurant}
              isLogged={!!(props.user && props.user._id)}
            />
            {isReservationEnabled ? (
              <button
                className="show-more-results grey"
                onClick={() => {
                  setReservation(true);
                }}
              >
                Prenota Ora
              </button>
            ) : null}
          </div>
          <div className="restaurant-details-info-score">
            <Score restaurant={restaurant} />
            <RestaurantReviews
              attributes={props.attributes}
              restaurant={restaurant}
              defaultCategory={
                restaurant &&
                restaurant.category &&
                restaurant.category.length > 0
                  ? restaurant.category[0]
                  : 10
              }
            />
            {restaurant.facebook &&
            restaurant.facebook.rating_count &&
            Number(restaurant.facebook.rating_count) > 0 &&
            restaurant.facebook.overall_star_rating ? (
              <FacebookReviews
                data={restaurant.facebook}
                restaurantName={restaurant.name}
              />
            ) : null}
            {reviewPopup ? (
              <WriteReview
                restaurant={restaurant}
                user={props.user}
                setRestaurant={rest => {
                  // console.log(rest.reviews);
                  setRestaurant(rest);
                }}
                hideAlert={setReviewPopup}
              />
            ) : null}
            {/* <div>
              <div style={{ width: "100%", display: "flex" }}>
                <button
                  className="show-more-results"
                  style={{ margin: "30px auto" }}
                  onClick={() => {
                    setReviewPopup(true);
                  }}
                >
                  Scrivi Una Recensione
                </button>
              </div>
            </div> */}
          </div>
          <div className="restaurant-details-info-description">
            <RestaurantInfo restaurant={restaurant} />
          </div>
        </div>
        {/* <div
          className="righthalf"
          style={{
            position: "absolute",
            background: "white",
            top: "50px",
            padding: "20px",
            left: "50%",
            zIndex: 99999
          }}
        >
          <RestaurantReservation
            defaultLanguage={"it"}
            userLanguage={"it"}
            t={props.t}
            showReservationPopup={true}
            showReservation={true}
            restaurantId={restaurant._id}
            user={props.user}
            restaurant={restaurant}
            // positions: PropTypes.array.isRequired
            reservation={restaurant.reservation}
          />
        </div> */}
        {/* <div className="item-body">
          <div className="lefthalf">
            <RestaurantInfo restaurant={restaurant} />
          </div>
          <div className="righthalf">
            <div className="restaurant-details-image-container-big">
              <div className="restaurant-detail-image-container-side">
                <RestaurantImage restaurant={restaurant} />
              </div>
              <div className="restaurant-details-map-next-image-container">
                <BaseMap restaurant={restaurant} />
              </div>
            </div>
            {restaurant.checkIns && restaurant.checkIns.length > 0 ? (
              <div
                style={{ marginBottom: "30px", float: "left", width: "100%" }}
              >
                <div
                  className="restaurant-details-reviews-count"
                  style={{ marginBottom: "30px" }}
                >
                  <span style={{ fontSize: "21px" }}>
                    {restaurant.checkInNumber || restaurant.checkIns.length}
                  </span>{" "}
                  {restaurant.checkInNumber > 1 ? "check-ins" : "check-in"}
                </div>
              </div>
            ) : null}
            <RestaurantReviews
              attributes={props.attributes}
              restaurant={restaurant}
              defaultCategory={
                restaurant &&
                restaurant.category &&
                restaurant.category.length > 0
                  ? restaurant.category[0]
                  : 10
              }
            />
            {restaurant.facebook &&
            restaurant.facebook.rating_count &&
            Number(restaurant.facebook.rating_count) > 0 &&
            restaurant.facebook.overall_star_rating ? (
              <FacebookReviews
                data={restaurant.facebook}
                restaurantName={restaurant.name}
              />
            ) : null}
          </div>
        </div> */}
      </div>
    );
  }
  return null;
}

RestaurantDetails.propTypes = {
  user: PropTypes.object.isRequired,
  attributes: PropTypes.object.isRequired
};
export default withRouter(RestaurantDetails);
